import { INavCat } from '../sidebar/sidebar.definitions';

export const MockHeader: readonly INavCat[] = [
  {
    title: 'Login',
    url: 'login',
  },
  {
    title: 'Register',
    url: 'register',
  },
];
